export interface FieldConfigData {
  contents?: Array<any>;
}

export class FieldConfig {
  // Primitive Types
  static readonly TYPE_STRING       = 'string';
  static readonly TYPE_NUMBER       = 'number';
  static readonly TYPE_MONEY        = 'money';
  static readonly TYPE_EMAIL        = 'email';
  static readonly TYPE_GENDER       = 'gender';
  static readonly TYPE_PHONE        = 'phone';
  static readonly TYPE_BOOLEAN      = 'boolean';
  static readonly TYPE_BOOLEAN_DATA = 'boolean_data';
  static readonly TYPE_DATE         = 'date';
  static readonly TYPE_DROPDOWN     = 'dropdown';

  // Derived from primitives
  static readonly TYPE_M2 = 'm2';
  static readonly TYPE_M3 = 'm3';

  // Special Case
  static readonly TYPE_RELATION = 'relation';

  // Cached RelationConfigs
  static readonly TYPE_NATIONALITY           = 'nationality';
  static readonly TYPE_COUNTRY               = 'nationality';
  static readonly TYPE_RELATIONCONFIG        = 'relation_config';
  static readonly TYPE_CONTRACT              = 'contract';
  static readonly TYPE_CANCELLATION_PERIOD   = 'cancellation_period';
  static readonly TYPE_HOME_TYPES            = 'home_types';
  static readonly TYPE_MORTGAGE              = 'mortgage_types';
  static readonly TYPE_LIFE_INSURANCE        = 'life_insurances_type'; // Added by Joseph
  static readonly TYPE_EDUCATION_CONFIG      = 'education_config';
  static readonly TYPE_MARITAL_STATUS_CONFIG = 'marital_status_config';

  // JsonApiEntities
  static readonly TYPE_FINANCIAL_COMPANIES = 'financial_companies';
  static readonly TYPE_HOMES               = 'homes';
  static readonly TYPE_PERSON              = 'person';

  // Added by Joseph
  static readonly TYPE_EDUCATION = 'education';

  static readonly TYPE_ZAKELIJKSTRING = 'addedField';
  static readonly TYPE_ZAKELIJKTDATE = 'addedDate';
  static readonly TYPE_ZAKELIJKMONEY = 'addedMoney';

  static readonly TYPE_LOONDIENSTSTRING = 'loonString';
  static readonly TYPE_LOONDIENSTDATE = 'loonDate';
  static readonly TYPE_LOONDIENSTBOOLEAN = 'loonBool';
  static readonly TYPE_LOONDIENSTCONTRACT = 'loonContract';
  static readonly TYPE_LOONDIENSTMONEY = 'loonMoney';
  static readonly TYPE_LOONDIENSTVAL = 'dertiende';
  static readonly TYPE_VAKANTIEGELD = 'vakantiegeld';

  constructor(
    public name,
    public type,
    public label                       = null,
    public data: FieldConfigData | any = null,
    public logoIcon                    = '',
  ) {
  }
}
